module.exports = __webpack_public_path__ + "static/media/casa.83fa6700.png";